"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = files;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var _Constants = require("../Constants");

var _file = require("../utils/file");

var defaultState = _immutable.default.Map({
  files: new _immutable.default.OrderedMap()
});

function files() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      file = action.file,
      tempId = action.tempId,
      originalId = action.originalId,
      progress = action.progress,
      tempUrl = action.tempUrl,
      tempFile = action.tempFile,
      folderId = action.folderId,
      dimensions = action.dimensions;
  var nameAndExtension = tempFile ? (0, _file.splitNameAndExtension)(tempFile) : {};

  switch (type) {
    case _ActionTypes.UPLOAD_FILE_ATTEMPTED:
      return state.setIn(['files', tempId], _immutable.default.Map(Object.assign({
        progress: 0,
        id: tempId,
        name: nameAndExtension.name,
        title: nameAndExtension.name,
        extension: nameAndExtension.extension,
        encoding: nameAndExtension.extension,
        type: (0, _file.getType)(nameAndExtension.extension),
        size: tempFile.size,
        created: Date.now(),
        updated: Date.now(),
        temp: true,
        meta: _immutable.default.Map(),
        folder_id: folderId || null,
        tempUrl: tempUrl,
        category: _Constants.ObjectCategory.FILE
      }, dimensions)));

    case _ActionTypes.SAVE_EDIT_ATTEMPTED:
      return state.setIn(['files', tempId], _immutable.default.Map({
        id: tempId,
        name: file.get('name'),
        title: file.get('name'),
        extension: file.get('extension'),
        type: _Constants.FileTypes.IMG,
        temp: true,
        size: 0,
        url: tempUrl,
        created: Date.now(),
        updated: Date.now(),
        meta: _immutable.default.Map(),
        category: _Constants.ObjectCategory.FILE,
        originalId: originalId
      }));

    case _ActionTypes.UPLOAD_FILE_SUCCEEDED:
    case _ActionTypes.UPLOAD_FILE_FAILED:
    case _ActionTypes.SAVE_EDIT_SUCCEEDED:
      return state.deleteIn(['files', tempId]);

    case _ActionTypes.UPLOAD_FILE_PROGRESS:
      return state.setIn(['files', tempId, 'progress'], progress);

    default:
      return state;
  }
}

module.exports = exports.default;